export default __webpack_public_path__ + "static/media/apple.3647e340.webp";